import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";

import * as Constants from "../frontend/Constants";

const baseUrl = Constants.URL();

const List = ({ Id, CreatedDate, Title, IsAdmin }) => {
  const [fileName, setFileName] = useState("");
  const [HTMLFileName, setHTMLFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `${baseUrl}Newsletters/file/normal/${Id}/filename`
      );
      const result = await response.json();
      setFileName(result.filename);

      const htmlResponse = await fetch(
        `${baseUrl}Newsletters/file/HTML/${Id}/filename`
      );
      const htmlResult = await htmlResponse.json();
      setHTMLFileName(htmlResult.filename);
    };

    fetchData();
  }, []);

  const handleDownload = async (event) => {
    var name = event.currentTarget.name;
    setLoading(true);

    var url =
      name === "html"
        ? `${baseUrl}Newsletters/file/HTML/${Id}`
        : `${baseUrl}Newsletters/file/normal/${Id}`;
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name === "html" ? `${HTMLFileName}` : `${fileName}`;
    document.body.appendChild(link);
    link.click();
    setLoading(false);
  };

  const history = createBrowserHistory();

  const onClick = (event) => {
    redirect(`/SendEmailConfirm/id=` + Id);
  };

  const deleteNewsletter = () => {
    redirect(`/DeleteNewsletterConfirm/id=` + Id);
  };

  const redirect = (path) => {
    const location = {
      pathname: path,
      state: { fromDashboard: true },
    };

    history.push(location);
    window.location.reload();
  };

  return (
    <div>
      <hr />
      <div className="u-padding">
        <span className="span" key={Id}>
          {CreatedDate}
        </span>
        <span> - </span>
        <button
          className="buttonAnchored"
          id={Id}
          name="normal"
          key={Id}
          disabled={loading}
          onClick={handleDownload}
        >
          {Title}
        </button>
        {loading && <div>Downloading...</div>}
        <br />
        {IsAdmin && (
          <button
            className="buttonAnchored"
            id={Id}
            name="html"
            key={Id}
            disabled={loading}
            onClick={handleDownload}
          >
            HTML Code
          </button>
        )}
      </div>
      {IsAdmin && (
        <div className="AdminButtons">
          <button
            className="Button marginRight addNewsletterButton"
            onClick={onClick}
          >
            Email newsletter
          </button>
          <button
            id={Id}
            className="Button DeleteButton addNewsletterButton"
            onClick={deleteNewsletter}
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default withRouter(List);
